import { render, staticRenderFns } from "./DoctorMap.vue?vue&type=template&id=0ce53e7d&scoped=true&"
import script from "./DoctorMap.vue?vue&type=script&lang=js&"
export * from "./DoctorMap.vue?vue&type=script&lang=js&"
import style0 from "./DoctorMap.vue?vue&type=style&index=0&id=0ce53e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce53e7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle})
